<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input ttLabel="poh_keyno" [ttModel]="menu.poh_keyno" ttReadonly></tt-input>
            <tt-input ttLabel="stockplace_name" [ttModel]="menu.stockplace_name" ttReadonly></tt-input>

            <tt-tabs *ngIf="'mobile' | mediaQuery" [(ttSelectedId)]="selectedBgPohMain">
                <tt-tab ttId="COMPONENTS" ttLabel="gb_poh_main_components"></tt-tab>
                <tt-tab ttId="PO" ttLabel="gb_poh_main_pos"></tt-tab>
                <tt-tab ttId="FUNCTIONS" ttLabel="gb_poh_main_functions"></tt-tab>
            </tt-tabs>

            <tt-tabs *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery" [(ttSelectedId)]="selectedBgPohMain">
                <tt-tab ttId="COMPONENTS" ttLabel="gb_poh_main_components"></tt-tab>
                <tt-tab ttId="PO" ttLabel="gb_poh_main_pos"></tt-tab>
            </tt-tabs>

            <div *ngIf="'mobile' | mediaQuery" [hidden]="selectedBgPohMain !== 'FUNCTIONS'">
                <tt-button [ttText]="'poh_print'" (ttClick)="goToFunc('selectreport')" ttTextAlign="center" ttIcon="fa fa-print"></tt-button>
                <tt-button [ttText]="'poh_email_send'" (ttClick)="goToFunc('emailcreate')" ttTextAlign="center" ttIcon="fa fa-envelope"></tt-button>
                <tt-button ttText="prod_cancel_caseqtystyle_ol" (ttClick)="cancelCaseQtyOl()" [ttSpin]="cancellingCaseQtyOl" ttIcon="fas fa-sync"></tt-button>
                <tt-button ttText="prod_cancel_caseqtystyle" (ttClick)="cancelCaseQty()" [ttSpin]="cancellingCaseQty" ttIcon="fas fa-sync"></tt-button>
                <tt-button [ttText]="changeStatusText" [ttDisabled]="changeStatusDisabled" (ttClick)="changeStatus()" [ttLoading]="changingStatus" ttIcon="fas fa-sync"></tt-button>
                <tt-button ttText="tt_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
                <tt-button-settings *ngIf="menu.show_setting === '1'"></tt-button-settings>
            </div>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
            <tt-button [ttText]="'poh_print'" (ttClick)="goToFunc('selectreport')" ttTextAlign="center" ttIcon="fa fa-print"></tt-button>
            <tt-button [ttText]="'poh_email_send'" (ttClick)="goToFunc('emailcreate')" ttTextAlign="center" ttIcon="fa fa-envelope"></tt-button>
            <tt-button ttText="prod_cancel_caseqtystyle_ol" (ttClick)="cancelCaseQtyOl()" [ttSpin]="cancellingCaseQtyOl" ttIcon="fas fa-sync"></tt-button>
            <tt-button ttText="prod_cancel_caseqtystyle" (ttClick)="cancelCaseQty()" [ttSpin]="cancellingCaseQty" ttIcon="fas fa-sync"></tt-button>
            <tt-button [ttText]="changeStatusText" [ttDisabled]="changeStatusDisabled" (ttClick)="changeStatus()" [ttLoading]="changingStatus" ttIcon="fas fa-sync"></tt-button>
            <tt-button ttText="tt_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
            <tt-button-settings *ngIf="menu.show_setting === '1'"></tt-button-settings>
        </tt-card>
    </div>

    <div *ngIf="selectedBgPohMain === 'COMPONENTS'">
        <div *ngIf="'mobile' | mediaQuery">
            <tt-list-legacy class="col-xs-12 p-5" [listItems]="itemsListComponents" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>

            <tt-card class="col-xs-12 p-5" *ngIf="menu.setting_show_pohfinish_create === '1'">
                <tt-button [ttText]="'tt_goto_pofinish'" (ttClick)="goToFunc('pofinishprod')" ttTextAlign="center" ttIcon="fas fa-check" [ttLoading]="goingToPoFinish"></tt-button>
            </tt-card>
        </div>

        <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
            <tt-divider ttRememberId="poh_dividers">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="80">
                        <tt-list-legacy class="col-xs-12 p-5" [listItems]="itemsListComponents" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>

                        <tt-card class="col-xs-12 p-5" *ngIf="menu.setting_show_pohfinish_create === '1'">
                            <tt-button [ttText]="'tt_goto_pofinish'" (ttClick)="goToFunc('pofinishprod')" ttTextAlign="center" ttIcon="fas fa-check" [ttLoading]="goingToPoFinish"></tt-button>
                        </tt-card>
                    </tt-divider-pane>

                    <tt-divider-pane ttSize="20"></tt-divider-pane>
                </tt-divider-columns>
            </tt-divider>
        </div>
    </div>

    <div class="height-full" *ngIf="selectedBgPohMain === 'PO'">
        <tt-list-legacy *ngIf="'mobile' | mediaQuery" class="col-xs-12 p-5" [listItems]="itemsListProductionOrders" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
        
        <div class="height-full p-5" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
            <tt-grid *ngIf="!!gridProductionOrders" class="flex-1 height-full" [(ttOptions)]="gridProductionOrders"></tt-grid>
        </div>
    </div>
</tt-page>
